import {ButtonGroup} from '@primer/react'
import {clsx} from 'clsx'
import {NavButtonItem} from '../../primitives/NavItemLink'

import styles from './Search.module.css'
import {CommandPaletteIcon, SearchIcon} from '@primer/octicons-react'
import {useTopNavContext} from '../../primitives/TopNav'

export type SearchProps = {
  show?: boolean
  searchHotkey?: string
  showCommandPalette?: boolean
  isSearchPage?: boolean
}

export function Search({show, searchHotkey, showCommandPalette, isSearchPage}: SearchProps) {
  const {searchOpen, searchTextBlocks, openSearch} = useTopNavContext()

  const handleSearchClick = (e: React.MouseEvent) => {
    openSearch()
    e.preventDefault()
  }

  if (!show) {
    return null
  }

  return (
    <>
      <ButtonGroup
        className={clsx(styles.searchButtonGroup, isSearchPage && styles.searchPage, searchOpen && styles.hideButtons)}
      >
        <NavButtonItem
          className={styles.searchButton}
          onClick={handleSearchClick}
          icon={SearchIcon}
          analyticsKey="SEARCH"
          aria-label="Search or jump to…"
          linkText={
            searchTextBlocks && searchTextBlocks.length > 0 ? (
              searchTextBlocks.map((block, index) => {
                return (
                  // eslint-disable-next-line @eslint-react/no-array-index-key
                  <span key={`value-${index}`} className={clsx(styles.text, styles[block.type])}>
                    {block.value}
                  </span>
                )
              })
            ) : (
              <span className={clsx(styles.placeholder, styles.text, styles.value)}>
                Type <kbd className={styles.kbd}>/</kbd> to search
              </span>
            )
          }
        />
        {showCommandPalette && (
          <NavButtonItem
            className="js-activate-command-palette"
            icon={CommandPaletteIcon}
            aria-label="Command palette"
            analyticsKey="COMMAND_PALETTE"
          />
        )}
      </ButtonGroup>
      <NavButtonItem
        icon={SearchIcon}
        aria-label="Search or jump to…"
        aria-expanded={searchOpen}
        aria-haspopup="dialog"
        hotkey={searchHotkey}
        onClick={handleSearchClick}
        className={styles.smallSearchButton}
        analyticsKey="SEARCH"
      />
    </>
  )
}

try{ Search.displayName ||= 'Search' } catch {}